<template>
  <div>
    <el-dialog :width="Diawidth" :visible.sync="dialogVisible" v-dialogDrag :before-close="handleClose"
      :close-on-click-modal="true" :show-close="true" :close-on-press-escape="true">
      <span slot='title' class="el-dialog__title" style="font-size: 20px;">事件详细报告</span>
      <div class="neirong">
        <iframe :src="itemData.url" id="iframeId" frameborder="0" style="width: 100%; height: 100%"></iframe>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    props: ['itemData'],
    data() {
      return {
        dialogVisible: true,
        Diawidth: "35%",
        pdfurl: ''
      }
    },
    mounted() {},
    methods: {
      handleClose(done) {
        this.dialogVisible = false;
        this.$emit("cancel", {
          "dialogVisible": this.dialogVisible
        })
      },
    }
  }
</script>

<style scoped>
  .neirong {
    width: 100%;
    height: 100%;
  }
  >>>.el-dialog {
    height: 700px;
    background: url(../../common/images/dialog.png) no-repeat center;
    background-size: 100% 100%;
  }

  >>>.el-dialog__body {
    height: 610px;
    padding-top: 0;
  }

  >>>.el-dialog__header {
    /* border: none; */
    padding-left: 0;
    margin: 10px 20px 8px 20px;
  }

  >>>.el-dialog__body, .el-dialog__footer{
      background: transparent;
  }
</style>
